import angular from 'angular';
import Resizable from 'resizable';

const modalResizableDirective = /* @ngInject */ (
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {import('angular').IWindowService} */ $window,
) => ({
	restrict: 'A',
	scope: {
		resizing: '=',
	},
	link:     (/** @type {any} */ scope, /** @type {import('angular').IRootElementService} */ element) => {
		const resizable = new Resizable(element.closest('.modal-dialog').get(0), {
			draggable: false,
		});
		resizable.on('resizestart', () => {
			$timeout(() => {
				scope.resizing = true;
			});
		});
		resizable.on('resize', () => {
			$window.dispatchEvent(new Event('resize'));
		});
		resizable.on('resizeend', () => {
			$timeout(() => {
				scope.resizing = false;
			});
		});
	},
});

angular.module('app')
	.directive('modalResizable', modalResizableDirective);
